export default __webpack_public_path__ + "static/form-default-values-dont-55dd81b296d364a11172bf9df86ac9757e37f64bcee8ddc9373cee24eb9724ac.png";